<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { onMount } from 'svelte';

    import TemplateStandard from '../../shared/TemplateStandard.svelte';
    import FilterVehicles from '../Filter/FilterVehicles.svelte';
    import { mainMenu } from '../../../stores/store';
    import ButtonAddSomething from '../../shared/ButtonAddSomething.svelte';
    import TemplateHeaderTrio from '../../shared/TemplateHeaderTrio.svelte';
    import RouteTypeList from './RouteTypeList.svelte';
    import IconBack from '../../shared/Icons/IconBack.svelte';
    import InlineInfoAboutAccountDisabilities from '../../shared/InlineInfoAboutAccountDisabilities.svelte';
    import { canWrite, writeDisabledBanner } from '../../shared/Permissions/writeAccess';
    let addMode = false;
    let letAddVehicle: boolean = false;
    let showFilter: boolean = false;

    onMount(() => {
        $mainMenu.currentPage = 'PageRouteType';
        return () => {};
    });
</script>

<TemplateStandard>
    <div slot="submenu"></div>
    <div slot="header" style="width: 100%;">
        <TemplateHeaderTrio>
            <div slot="main-header">
                {$_('Route types')}
            </div>
            <div slot="main-search"></div>
            <div slot="main-buttons">
                {#if letAddVehicle}
                    <ButtonAddSomething
                        on:click={() => {
                            addMode = !addMode;
                        }}
                        text={$_('Add route type')}
                    />
                {/if}
            </div>
        </TemplateHeaderTrio>
    </div>
    <div slot="content-header"></div>
    <div slot="content" style="overflow-y: auto; flex: 1; display: flex; flex-direction: column;">
        <div
            style="margin: 20px 0; overflow-y: auto; flex: 1; display: flex; flex-direction: column;"
        >
            {#if !$canWrite}
                <InlineInfoAboutAccountDisabilities
                    center={false}
                    text={$_(writeDisabledBanner)}
                />
            {/if}
            <RouteTypeList />
        </div>
    </div>
</TemplateStandard>

<style>
</style>
